import React, { useState, useEffect, useContext } from 'react';
import { Button, Card, Col, DatePicker, message, Row, Select } from 'antd';
import { ErrorMessage, useFormikContext } from 'formik';
import Item from '../../components/Form/Item';
import axios from '../../util/Api';
import { PROJECT_DIVISIONS } from '../Register/options';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { ParamsContext } from '../Context/ParamsContext';
import DivisionForm from '../Register/DivisionForm';

const { Option } = Select;

const SwitchForm = (props) => {
  const { id } = useContext(ParamsContext);
  const formik = useFormikContext();
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    if (formik.values.project.division) {
      fetchProjects();
    }
  }, [formik.values.project.division]);

  const fetchProjects = () => {
    setLoading(true);
    const url = `/project/options`;
    axios.get(url, { params: { sort: 'status', division: formik.values.project.division } }).then(({ data }) => {
      setProjects(data.projects);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat daftar proyek");
    });
  }

  return (
    <Card className="gx-card" title={`Pindah Bekerja di Proyek?`}>
      <Item name="Divisi Operasi" required>
        <DivisionForm />
      </Item>
      <Item name="Nama Proyek" required>
        <Select
          showSearch
          loading={loading}
          defaultValue={formik.values.project.id}
          onChange={(value) => formik.setFieldValue("project.id", value)}
          style={{ width: 320 }}
          placeholder="Pilih proyek"
          optionFilterProp="label"
        >
          {projects.map((prj, key) => {
            return <Option value={prj.id} key={`project-${key}`} label={prj.name}>
              <Row>
                <Col span={12}>
                  {prj.name}
                  <div>
                    {prj.code}
                  </div>
                </Col>
                <Col span={12} className="gx-text-right">{prj.status.label}</Col>
              </Row>
            </Option>
          })}
        </Select>
        <ErrorMessage component="div" name="project.id" className="gx-mt-2 gx-text-red" />
      </Item>
      <Item name="Tanggal Masuk" required>
        <DatePicker
          onChange={(value) => {
            formik.setFieldValue("project.start", value.format("YYYY-MM-DD"));
          }}
          style={{ width: 320 }}
        />
        <ErrorMessage component="div" name="project.start" className="gx-mt-2 gx-text-red" />
      </Item>
      <Item name="Berakhir" required>
        <DatePicker
          onChange={(value) => {
            formik.setFieldValue("project.end", value.format("YYYY-MM-DD"));
          }}
          style={{ width: 320 }}
          disabledDate={(current) => {
            return current && current < moment(new Date(formik.values.project.start)).endOf('day')
          }}
        />
        <ErrorMessage component="div" name="project.end" className="gx-mt-2 gx-text-red" />
      </Item>

      <div className="gx-mt-3">
        <Row>
          <Col span={6}></Col>
          <Col span={18}>
            <Button type="primary" htmlType="submit">Simpan</Button>
            <Link to={`/passport/detail?id=${id}`} className="ant-btn ant-btn-secondary">Batal</Link>
          </Col>
        </Row>
      </div>
    </Card>
  );
}

export default SwitchForm;